/**
 * 推荐问题配置
 * 用于首页展示的推荐问题列表
 */
export const DEFAULT_SUGGESTIONS = [
  { icon: '🍎', text: '苹果的特色' },
  { icon: '🍎', text: '米奇拉苹果的特点' },
  { icon: '🍲', text: '吃火锅需要什么菜' },
  { icon: '🥗', text: '血压高适合吃什么菜' },
  { icon: '🥬', text: '绿叶菜促销' },
  { icon: '🍉', text: '水果应该如何陈列' },
];

